module.exports = __webpack_public_path__ + "img/persons-icon.686f7757.png";